import React from 'react';
import { IconDeleteDisabled } from '@creditas-ui/icons';
import { GlobalIcons } from '@creditas-ui/global-icons';
import { ButtonSecondary } from '@creditas-ui/button';
import { Typography } from '@creditas-ui/typography';
import { Wrapper } from './Header.template.style';
import { useModalContext } from '../../../hooks';
export var HeaderTemplate = _ref => {
  var {
    title,
    hideCloseIcon
  } = _ref;
  var {
    closeModal,
    allowClose
  } = useModalContext();
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "bodyMdLight",
    children: title,
    color: "neutral.90",
    component: "h3"
  }), !hideCloseIcon && allowClose && /*#__PURE__*/React.createElement(ButtonSecondary, {
    onClick: closeModal,
    "aria-label": "close modal",
    "data-testid": "icon-close-button"
  }, /*#__PURE__*/React.createElement(GlobalIcons, {
    Icon: IconDeleteDisabled,
    size: "medium"
  })));
};
//# sourceMappingURL=Header.template.js.map